const customJSSelectors = {};
class customJS {
    constructor() {
        this.initDomevents();
    }
    /**
     * DOM events
     */
    initDomevents() {
        document.querySelectorAll('[data-changeVehicleType]').forEach(input => {
            input.addEventListener('click', event => {
                event.preventDefault();
                let targetEle = event.target.closest('[data-vehicleType]');
                let selectedVehicle = targetEle.getAttribute('data-vehicleType');
                document.querySelectorAll('.vehicle_container').forEach(btn => {
                    btn.classList.remove('open');
                })
                document.querySelectorAll(`[data-show="${selectedVehicle}"]`).forEach(ele => {
                    ele.classList.add('open');
                    ele.querySelector('[data-year-wrap] .custom-dropdown')?.classList.remove('disabled');
                    ele.querySelector('[data-type-wrap] .custom-dropdown')?.classList.remove('disabled');
                    ele.querySelector('[data-side-year-wrap] .custom-dropdown')?.classList.remove('disabled');
                    ele.querySelector('[data-turf-type-wrap] .custom-dropdown')?.classList.remove('disabled');

                    ele.querySelector('[data-sahdt-year-wrap] .custom-dropdown')?.classList.remove('disabled');
                    ele.querySelector('[data-sahdt-type-wrap] .custom-dropdown')?.classList.remove('disabled');
                    ele.querySelector('[data-sahdt-side-year-wrap] .custom-dropdown')?.classList.remove('disabled');
                  ele.querySelector('[data-sahdt-turf-type-wrap] .custom-dropdown')?.classList.remove('disabled');
                })
                // document.querySelector(`#${selectedVehicle}`).classList.add('open');
            })
        })    
        // document.querySelectorAll('custom-select .custom-dropdown-toggle').forEach(ele => {
        //     ele.addEventListener('click', event => {
                
        //         document.querySelectorAll('.vehicle-custom-select').forEach(btn => {
        //             console.log('helloooo',btn);
        //             btn.classList.remove('open');
        //         });
        
        //         const nextDropdown = ele.nextElementSibling;
        //         if (nextDropdown) {
        //             nextDropdown.classList.toggle('open');
        //         }
        //     });
        // });
        
    }
}
typeof customJS !== 'undefined' && new customJS();


document.addEventListener('DOMContentLoaded', () => {
    // Select the elements
    const iframeParent = document.querySelectorAll('.article-content iframe');
    const iframeParent1 = document.querySelectorAll('.article-description_wrapper iframe');
    const iframeParent2 = document.querySelectorAll('.pxFormGenerator iframe');

    // Loop through each selected element
    iframeParent.forEach(function (element) {
        element.setAttribute('title', 'Description of the iframe for Articles');
    });
    iframeParent1.forEach(function (element) {
        element.setAttribute('title', 'Description of the iframe for Articles');
    });
    iframeParent2.forEach(function (element) {
        element.setAttribute('title', 'Description of the iframe for Form');
    });

});

document.querySelectorAll("[data-model-popup-selected]").forEach(button => {
    button.addEventListener('click', event => {
        let target = event.target;
        let data_id = target.getAttribute("data-id");
        let parentElement = target.closest(".pdp-vehicle-model");
        
        if (parentElement) {
            parentElement.querySelectorAll(".modal-body").forEach(el => el.classList.add("d-none"));
            let selectedModal = parentElement.querySelector("#" + data_id);
            if (selectedModal) {
                selectedModal.classList.remove("d-none");
            }
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const closeButton = document.querySelector(".pdp-vehicle-model .close");
    if (closeButton) {
        closeButton.addEventListener("click", event => {
            event.stopPropagation();
            window.location.href = "https://www.tigertough.com/";
        });
    }
});

if(document.querySelector(".block__model-vehicle-shopping button") != null){
    document.querySelector(".block__model-vehicle-shopping button").addEventListener("click", (event) => {
        let target = event.target;
        target.closest(".modal").classList.remove("open");
        document.querySelector("#site-overlay").classList.remove("overlay--body")
        document.querySelector("body").classList.remove("scroll-fixed");
        // setCookie("pdp-popup-access","true", 24);
    });
}

if(document.querySelector(".pdp-vehicle-model") != null){
//     function setCookie(cname, cvalue, hours) {
//         var d = new Date();
//         d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
//         var expires = "expires=" + d.toUTCString();
//         document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
//     }
   
//    function getCookiepdp(cname) {
//         var name = cname + "=";
//         var decodedCookie = decodeURIComponent(document.cookie);
//         var ca = decodedCookie.split(';');
//         for(var i = 0; i < ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0) == ' ') {
//             c = c.substring(1);
//         }
//         if (c.indexOf(name) == 0) {
//             return c.substring(name.length, c.length);
//         }
//         }
//         return "";
//    }
   
//    function checkCookiepdp() {
//         var user = getCookiepdp("pdp-popup-access");
//         if (user == "") {
//             const referrer = document.referrer;
//             const searchEngines = ["google.", "bing.", "yahoo.", "duckduckgo.", "yandex."];

//             if (referrer && searchEngines.some(engine => referrer.includes(engine))) {
//                 document.querySelector(".pdp-vehicle-model .modal").classList.add("open");
//                 document.querySelector("#site-overlay").classList.add("overlay--body");
//                 document.body.classList.add("scroll-fixed");
//             }
//         }
//     }

    document.addEventListener("DOMContentLoaded", () => {
        // checkCookiepdp();
        const referrer = document.referrer;
        const searchEngines = ["google.", "bing.", "yahoo.", "duckduckgo.", "yandex."];

        if (referrer && searchEngines.some(engine => referrer.includes(engine))) {
            document.querySelector(".pdp-vehicle-model .modal").classList.add("open");
            document.querySelector("#site-overlay").classList.add("overlay--body");
            document.body.classList.add("scroll-fixed");
        }
    });
}